module.exports = __webpack_public_path__ + "static/media/27-2.a3efffcc.mp3";